import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ValueStackSection } from '../components/ValueStackSection';
import { BonusSection } from '../components/BonusSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { UrgencySection } from '../components/UrgencySection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  useEffect(() => {
    // Set page title
    document.title = 'MEGAPACK: De 0 a Ventas';
    // Set favicon
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = 'https://cdn.magicpatterns.com/uploads/f6mu5nkxRNiHdhFEj7Ka9v/FAVICON.png';
  }, []);
  useEffect(() => {
    // Inject Meta Pixel safely
    const pixelId = '999348842752724';
    // @ts-ignore
    if (window.fbq) return;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // @ts-ignore
    window.fbq = n;
    // @ts-ignore
    window._fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    window.fbq('init', pixelId);
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-white font-sans selection:bg-yellow-400 selection:text-black" data-id="element-297">
      <HeroSection data-id="element-298" />
      <ProblemSection data-id="element-299" />
      <SolutionSection data-id="element-300" />
      <ValueStackSection data-id="element-301" />
      <BonusSection data-id="element-302" />
      <BenefitsSection data-id="element-303" />
      <TestimonialsSection data-id="element-304" />
      <ObjectionsSection data-id="element-305" />
      <UrgencySection data-id="element-306" />
      <OfferSection data-id="element-307" />
      <GuaranteeSection data-id="element-308" />
      <FinalCTASection data-id="element-309" />

      <SocialProofPopup data-id="element-310" />
    </main>;
}